import axios from "axios";
import { useEffect, useState } from "react";

export default function EmailTab() {
  const [emailTo, setEmailTo] = useState("");
  const [list, setList] = useState([]);
  const [editId, setEditId] = useState(null);

  const API = "https://notification-dashboard-fullstack.onrender.com/api/emails";

  const isValidEmail = (e) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e);

  const load = async () => setList((await axios.get(API)).data);

  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();

    if (!emailTo) return alert("Enter email");
    if (!isValidEmail(emailTo)) return alert("Invalid email");

    editId
      ? await axios.put(`${API}/${editId}`, { emailTo })
      : await axios.post(API, { emailTo });

    setEmailTo("");
    setEditId(null);
    load();
  };

  return (
    <>
      <form onSubmit={submit}>
        <input className="form-control mb-2"
          type="email"
          value={emailTo}
          onChange={(e) => setEmailTo(e.target.value)}
          placeholder="Enter Email"
        />
        <button className="btn btn-primary">
          {editId ? "Update" : "Send"}
        </button>
      </form>

      <table className="table table-hover mt-3">
        <thead><tr><th>#</th><th>Email</th><th>Time</th><th>Action</th></tr></thead>
        <tbody>
          {list.map((e, i) => (
            <tr key={e._id}>
              <td>{i + 1}</td>
              <td>{e.emailTo}</td>
              <td>{new Date(e.createdAt).toLocaleString()}</td>
              <td>
                <button className="btn btn-warning btn-sm me-2"
                  onClick={() => { setEmailTo(e.emailTo); setEditId(e._id); }}>
                  Edit
                </button>
                <button className="btn btn-danger btn-sm"
                  onClick={() => axios.delete(`${API}/${e._id}`).then(load)}>
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}
